import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  filter: "materialName",
  sort: "materialName"
}
const _hoisted_2 = {
  filter: "category",
  sort: "category"
}
const _hoisted_3 = {
  filter: "country",
  sort: "country"
}
const _hoisted_4 = {
  filter: "suggestedGramsPerSquareMeters",
  filterType: "number",
  sort: "suggestedGramsPerSquareMeters"
}
const _hoisted_5 = {
  filter: "cO2PerGrams",
  filterType: "number",
  sort: "cO2PerGrams"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { colspan: "10" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_11 = { class: "fs_14 text-muted" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_ctx.ready)
    ? (_openBlock(), _createBlock(_component_op_table, {
        key: 0,
        class: "table table-striped",
        items: _ctx.items,
        name: 'rawMaterials-' + _ctx.materialType
      }, {
        default: _withCtx((opData) => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_1, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Material",
                  text: "Material"
                })
              ]),
              _createElementVNode("td", _hoisted_2, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Category",
                  text: "Category"
                })
              ]),
              (_ctx.isProcessBased)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processKeys, (key) => {
                      return (_openBlock(), _createElementBlock("td", { key: key }, _toDisplayString(key), 1))
                    }), 128)),
                    _createElementVNode("td", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Apparel value at import",
                        text: "Apparel value at import"
                      })
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("td", _hoisted_3, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Country",
                        text: "Country"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_4, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "GRAMS Suggested",
                        text: "GRAMS Suggested"
                      })
                    ]),
                    _createElementVNode("td", _hoisted_5, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "CO2 Per Grams",
                        text: "CO2 Per Grams"
                      })
                    ])
                  ], 64)),
              _hoisted_6
            ])
          ]),
          _createElementVNode("tbody", null, [
            (opData.data.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                  _createElementVNode("td", _hoisted_8, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "No Elements Found",
                      text: "No Elements Found"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.RawMaterialConfigurationVM[]), (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(item.materialName), 1),
                _createElementVNode("td", null, _toDisplayString(item.category), 1),
                (_ctx.isProcessBased)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.processKeys, (key) => {
                        return (_openBlock(), _createElementBlock("td", { key: key }, [
                          (item.emissionFactorFootwearType[key] != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.emissionFactorFootwearType[key]), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
                        ]))
                      }), 128)),
                      _createElementVNode("td", _hoisted_11, [
                        (item.cO2PerGrams > 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.cO2PerGrams), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))
                      ])
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("td", null, [
                        (item.country)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item.country), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_15, "-"))
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.suggestedGramsPerSquareMeters), 1),
                      _createElementVNode("td", null, _toDisplayString(item.cO2PerGrams), 1)
                    ], 64)),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: ($event: any) => (_ctx.$emit('edit', item))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Edit",
                      text: "Edit"
                    })
                  ], 8, _hoisted_16)
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }, 8, ["items", "name"]))
    : _createCommentVNode("", true)
}